
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { State } from 'vuex-class';
import { AnswerType, IAnswerHypermediaRepresentation } from '../../shared/contracts/AnswerContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { performance } from '../../shared/services/PerformanceService';
import { IGroupDetailsState } from '../../store/contract';
import store from '../../store/store';
import GroupDetailsBase from './GroupDetailsBase.vue';

@Component({})
export default class AccountDetails extends GroupDetailsBase {

    @State('details') groupDetailState: IGroupDetailsState;

    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track(`account-details-${(to.params as any).id}`);
        await store.dispatch('details/fetchAccountAggregate', (to.params as any).id);
        next();
    }

    markPerformance() {
        this.$nextTick(() => {
            performance.end(`account-details-${this.id}`);
        });
    }

    protected relevantAnswerInSnapshot(answer: IAnswerHypermediaRepresentation): boolean {
        const accountId = this.groupDetailState.aggregate.itemId;
        if ((answer.answerType !== AnswerType.Project) && (answer.answerType !== AnswerType.Rotation)) {return true;}
        return (answer.accountId === accountId);
    }

    protected async filterAnswersFromSnapshots(snapshots: ISnapshotHypermediaRepresentation[]): Promise<ISnapshotHypermediaRepresentation[]> {
        return snapshots.map(snapshot => ({
            ...snapshot,
            answers: snapshot.answers.filter(a => this.relevantAnswerInSnapshot(a))
        }));
    }

}
